var images = {
    profileAge: require('@partipost-cm-new/app-preview/src/Images/profile-age.png'),
    profileContentType: require('@partipost-cm-new/app-preview/src/Images/profile-content-type.png'),
    profileFacebook: require('@partipost-cm-new/app-preview/src/Images/profile-facebook.png'),
    profileGender: require('@partipost-cm-new/app-preview/src/Images/profile-gender.png'),
    profileInstagram: require('@partipost-cm-new/app-preview/src/Images/profile-instagram.png'),
    profileLocation: require('@partipost-cm-new/app-preview/src/Images/profile-location.png'),
    profileMaritalStatus: require('@partipost-cm-new/app-preview/src/Images/profile-marital-status.png'),
    profileOccupation: require('@partipost-cm-new/app-preview/src/Images/profile-occupation.png'),
    profileTiktok: require('@partipost-cm-new/app-preview/src/Images/profile-tiktok.png'),
    profileTwitter: require('@partipost-cm-new/app-preview/src/Images/profile-twitter.png'),
    profileCampaignHistory: require('@partipost-cm-new/app-preview/src/Images/profile-campaign-history.png'),
};
export default images;
